import styles from "./SurveyUnavailable.module.scss";

import { useTranslation } from "react-i18next";

import { AppButton } from "@/modules/shared/components/AppButton";

interface SurveyUnavailableProps {
  onRetry: () => void;
  isRetrying?: boolean;
}

export const SurveyUnavailable = ({
  onRetry,
  isRetrying = false,
}: SurveyUnavailableProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{t("sessionSurvey.unavailable.title")}</h1>
      <p className={styles.subtitle}>
        {t("sessionSurvey.unavailable.subtitle")}
      </p>
      <AppButton onClick={onRetry} isLoading={isRetrying}>
        {t("sessionSurvey.unavailable.retry")}
      </AppButton>
    </div>
  );
};
